import { Ability } from '@casl/ability'
import { initialAbility } from '@/libs/acl/config'
import { getUserAbilities } from '@/composables/currentUser'

export default new Ability(getUserAbilities().concat(initialAbility))
